module.exports = __webpack_public_path__ + "static/media/chart1.3c86fe0d.png";